import { render, staticRenderFns } from "./InvoiceHasBeenReviewed.vue?vue&type=template&id=b31870b8&scoped=true"
import script from "./InvoiceHasBeenReviewed.vue?vue&type=script&lang=js"
export * from "./InvoiceHasBeenReviewed.vue?vue&type=script&lang=js"
import style0 from "./InvoiceHasBeenReviewed.vue?vue&type=style&index=0&id=b31870b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31870b8",
  null
  
)

export default component.exports